import { FormNavigationDependenciesKey } from '@cplug/frontend-core/models'
import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.provide(FormNavigationDependenciesKey, {
    notFoundUrl: '/dashboard/not-found'
  })
})
